'use client'

import { AddIcon, RemoveIcon } from '../../icons'
import {
    ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS,
    resolveIconButtonAriaLabel,
} from '../../../constants/iconButtonAriaLabelMessageKeys'
import { Button, ButtonVariants } from '../../atoms'
import React, { useContext } from 'react'
import { DictionaryContext } from '../../../providers'

interface Props {
    controlsAreOnLeft: boolean
    controlsAreSplit: boolean
    onDecrement: () => void
    onIncrement: () => void
}

export const FormNumberInputStepControls = ({
    controlsAreOnLeft,
    controlsAreSplit,
    onDecrement,
    onIncrement,
}: Props) => {
    const dictionary = useContext(DictionaryContext)
    return (
        <>
            <Button
                data-testid="decrement-button"
                variant={ButtonVariants.QUIET}
                className={`select-none -my-1px ${controlsAreOnLeft || controlsAreSplit ? '-order-2' : ''}`}
                onClick={onDecrement}
                icon={<RemoveIcon className="text-xxl " />}
                aria-label={resolveIconButtonAriaLabel(dictionary, ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.DECREMENT_VALUE)}
            />
            <Button
                data-testid="increment-button"
                variant={ButtonVariants.QUIET}
                className={`select-none -my-1px ${controlsAreOnLeft ? '-order-1' : ''}`}
                onClick={onIncrement}
                icon={<AddIcon className="text-xxl " />}
                aria-label={resolveIconButtonAriaLabel(dictionary, ICON_BUTTON_ARIA_LABEL_MESSAGE_KEYS.INCREMENT_VALUE)}
            />
        </>
    )
}
